<template>
  <div class="content-container">
    <van-nav-bar
      :title="$t('moduleTitles.workRecycle')"
      left-arrow
      @click-left="onClickBack"
      @click-right="onBatchAll"
      :right-text="$t('actionTitles.selectAll')"
    />
    <div class="notice">{{$t('descriptions.recycleNotice')}}</div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" @load="onLoadMore" :immediate-check="false">
        <van-checkbox-group ref="checkboxGroup" v-model="selectedRowKeys">
          <div class="work-wrapper" v-for="(work,index) in workList" :key="work.id">
            <div class="info-wrapper">
              <div class="left-wrapper" v-if="work.dir_id == undefined" @click="toFolder(work.id)">
                <div>
                  <img style="width: 40px; height: 40px" src="@/assets/img/fold.png" />
                </div>
                <div class="work-info">
                  <div class="info-title">{{work.name}}</div>
                </div>
              </div>
              <div class="left-wrapper" v-else>
                <div>
                  <img style="width: 40px; height: 40px" :src="work.thumb_path" />
                </div>
                <div class="work-info">
                  <div class="info-title">{{work.name}}</div>
                  <div class="info-description">{{work.create_time}}</div>
                </div>
              </div>
              <div class="right-wrapper" @click="toggle(index)">
                <van-checkbox ref="checkboxes" :name="work.id" :icon-size="16" />
              </div>
            </div>
          </div>
        </van-checkbox-group>
      </van-list>
    </van-pull-refresh>
    <batch-operate
      :selected-keys="selectedRowKeys"
      @close="selectedRowKeys=[]"
      @all="onBatchAllEmpty"
    >
      <batch-operate-item :text="$t('actionTitles.delete')" @click="batchDelete">
        <template v-slot:icon>
          <a-icon type="delete" />
        </template>
      </batch-operate-item>
      <batch-operate-item :text="$t('actionTitles.resume')" @click="batchRegain">
        <template v-slot:icon>
          <a-icon type="retweet" />
        </template>
      </batch-operate-item>
    </batch-operate>
  </div>
</template>

<style lang="less" scoped>
.content-container {
  background-color: #fff;
  min-height: 100vh;
}

.notice {
  padding: 10px;
  background-color: #fdfafa;
  font-size: 13px;
}

.work-wrapper {
  padding: 0px 10px 0px 10px;
  width: 100vw;

  .info-wrapper {
    padding: 10px 0px 10px 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 0.5px solid #efeeee;
    .left-wrapper {
      width: 80%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      overflow: hidden;
    }
    .right-wrapper{
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .work-info {
      margin-left: 10px;
    }
    .info-title {
      font-size: 1rem;
      color: rgba(0, 0, 0, 1);
      font-weight: 100;
    }
    .info-description {
      font-size: 0.8rem;
      color: gray;
    }
  }
}
</style>

<script>
import Vue from "vue";
import { List, PullRefresh, NavBar, Checkbox, CheckboxGroup, Icon } from "vant";
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(NavBar);
Vue.use(Checkbox);
Vue.use(Icon);
Vue.use(CheckboxGroup);

import "../../../assets/css/mobile.less";
import { mapGetters } from "vuex";
import BatchOperate from "../../components/BatchOperate";
import BatchOperateItem from "../../components/BatchOperateItem";
import DragUploader from "@/components/DragUploader";

import { queryRecycle, workDelete, workRegain } from "@/api/work";
export default {
  components: { BatchOperate, BatchOperateItem, DragUploader },
  props: {
    type: {
      type: Number,
      require: true,
    },
  },
  searchKey: {
    type: String,
    default: "",
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {
    searchKey(value) {
      this.searchForm.name = value;
    },
  },
  data() {
    return {
      searchForm: {
        pid: 0,
        name: this.searchKey,
        type: this.type,
        order: {},
      },
      refreshing: false,
      loading: false,
      finished: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      searchParam: {},
      workList: [],
      selectedRowKeys: [],
      folderDepthList: [],
      treeVisible: false,
      loadedKeys: [],
      treeData: [{ id: 0, name: this.$t("moduleTitles.root") }],
      selectedKeys: [],
      selectDirIds: [],
      renameVisible: false,
      renameObj: {},
      newName: "",
      upModelVisible: false,
    };
  },
  created() {},
  mounted() {
    this.onRefresh();
  },
  methods: {
    onClickBack() {
      this.$router.back();
    },
    onRefresh() {
      this.selectedRowKeys = [];
      this.pagination.current = 1;
      this.finished = false;
      this.refreshing = true;
      this.loading = true;
      this.loadData();
    },
    onLoadMore() {
      this.pagination.current += 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.searchParam = {
        ...this.searchForm,
        ...{ current_page: this.pagination.current, per_page: 10 },
      };

      queryRecycle(this.searchParam)
        .then((ret) => {
          this.loading = false;
          let data = ret.data.data;
          if (this.refreshing) {
            this.workList = data;
          } else {
            this.workList = [...this.workList, ...data];
          }
          this.refreshing = false;

          if (data.length < this.pagination.pageSize) {
            this.finished = true;
          }
          this.pagination.total = ret.data.total;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onBatchClose() {
      this.selectedRowKeys = [];
    },
    onBatchAll() {
      this.$refs.checkboxGroup.toggleAll(true);
    },
    onBatchAllEmpty() {
      this.$refs.checkboxGroup.toggleAll(false);
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    batchDelete() {
      if (this.selectedRowKeys.length > 0) {
        workDelete({ id: this.selectedRowKeys }).then((res) => {
          this.onRefresh();
          this.$message.success(this.$t("message.deleteSuccess"));
        });
      } else {
        this.$message.warning(this.$t("message.selectHint"));
      }
    },
    batchRegain() {
      if (this.selectedRowKeys.length > 0) {
        workRegain({ id: this.selectedRowKeys }).then((res) => {
          this.onRefresh();
          this.$message.success(this.$t("message.regainSuccess"));
        });
      } else {
        this.$message.warning(this.$t("message.selectHint"));
      }
    },
  },
};
</script>

